import exists from '../tools/exists';

if (exists('[data-behaviour*="form-redirect"]') || exists('[data-behaviour*="url-redirect"]')) {
    import('./redirect-to');
}

if (exists('[data-behaviour="toggle-faq"]')) {
    import('./faqs');
}

if (exists('[data-behaviour="back-to-top"]')) {
    import('./back-top-top');
}

if (exists('[data-behaviour="collapsible"]')) {
    import('./collapsible');
}

if (exists('[data-behaviour="disqus-comments"]')) {
    import('./disqus');
}

if (exists('.js-link-disabled')) {
    import('./disable-links');
}

if (exists('[data-behaviour="dropdown-select"]')) {
    import('./dropdown-select');
}

if (exists('[data-behaviour="dropdown-toggle"]')) {
    import('./dropdown-toggle');
}

if (exists('[data-behaviour="filter-date"]')) {
    import('./filter-date');
}

if (exists('.gfield') || exists('.validation_message') || exists('.gform_confirmation_message')) {
    import('./form-validation');
}

if (exists('[data-behaviour="toggle-menu"]')) {
    import('./footer-toggle');
}

if (exists('.c-year-selector') || exists('.c-latest-articles')) {
    import('./issues');
}

if (exists('[data-behaviour="google-map"]')) {
    import('./map');
}

if (exists('[data-behaviour="scroll-to"]')) {
    import('./scroll-to');
}

if (exists('[data-behaviour="empty-search"]')) {
    import('./search');
}

if (
    exists('[data-behaviour="circuits-slider"]') ||
    exists('[data-behaviour="database-slider"]') ||
    exists('[data-behaviour="database-slider-nested"]') ||
    exists('[data-behaviour="author-slider"]') ||
    exists('[data-behaviour="mobile-slider"]') ||
    exists('[data-behaviour="cta-slider"]') ||
    exists('[data-behaviour="news-slider"]') ||
    exists('[data-behaviour="simple-slider"]') ||
    exists('[data-behaviour="features-slider"]') ||
    exists('[data-behaviour="product-carousel"]') ||
    exists('[data-behaviour="video-slider"]') ||
    exists('.woocommerce-product-gallery') ||
    exists('[data-behaviour="subscription-reviews-slider"]')
) {
    import('./sliders');
}

if (exists('[data-behaviour="toggle-comparisons"]') || exists('[data-behaviour="subscription-comparison-item"]')) {
    require('./subscription-comparisons');
}

if (exists('[data-behaviour="toggle-tab"]') || exists('[data-behaviour="toggle-tab-plain"]')) {
    import('./tabs');
}

if (exists('body.single-post')) {
    import('./view-count');
}

if (exists('[data-behaviour="toggle"]')) {
    import('./toggle');
}

if (exists('[data-behaviour="nested-table"]')) {
    import('./nested-tables');
}

if (
    exists('[data-behaviour="driver-seasons-table"]') ||
    exists('[data-behaviour="team-seasons-table"]') ||
    exists('[data-behaviour="driver-teams-table"]') ||
    exists('[data-behaviour="driver-races-table"]') ||
    exists('[data-behaviour="team-races-table"]') ||
    exists('[data-behaviour="circuit-races-table"]') ||
    exists('[data-behaviour="race-qualifying-table"]') ||
    exists('[data-behaviour="race-results-table"]') ||
    exists('[data-behaviour="championship-standings-table"]') ||
    exists('[data-behaviour="championship-races-table"]')
) {
    import('./database-tables');
}

if (
    exists('[data-behaviour="championship-data-box"]') ||
    exists('[data-behaviour="race-data-box"]') ||
    exists('[data-behaviour="driver-data-box"]') ||
    exists('[data-behaviour="circuit-data-box"]')
) {
    import('./database-data-boxes');
}

if (exists('[data-behaviour="category-grid"]')) {
    import('./category-grid');
}

if (exists('[data-behaviour="row-toggle"]')) {
    import('./toggle');
}

if (
    exists('.pelcro-subscribe-button') ||
    exists('[data-behaviour="geo-price"]') ||
    exists('[data-behaviour="geo-links"]')
) {
    import('./geo');
}

if (exists('[data-behaviour="lazy-load"]')) {
    import('./lazy-load');
}

if (exists('.article-wrapper--public')) {
    import('./paywall');
}

if (exists('[data-behaviour="open-lightbox-media"]')) {
    import('./lightbox');
}

if( exists('[data-behaviour="subscription-swap-links"]') ) {
    import('./subscription-links');
}

window.onload = () => {
    if (exists('[data-behaviour="star-rating"]')) {
        import('./star-rating');
    }

    if (exists('[data-behaviour="react-adv-search"]') || exists('.react-pagination') || exists('.datatable-paging')) {
        import('./pagination-scrollTop');
    }
};
